export default "__VITE_ASSET__067c02eb__"